import { render, staticRenderFns } from "./create_account.vue?vue&type=template&id=b6c476b4&"
import script from "./create_account.vue?vue&type=script&lang=js&"
export * from "./create_account.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6c476b4')) {
      api.createRecord('b6c476b4', component.options)
    } else {
      api.reload('b6c476b4', component.options)
    }
    module.hot.accept("./create_account.vue?vue&type=template&id=b6c476b4&", function () {
      api.rerender('b6c476b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/login/create_account.vue"
export default component.exports